/**
 * Pongbot26 hero countdown: finds [data-pongbot26-hero-countdown], updates every second.
 * Data attributes: data-end (unix seconds), data-expired (hide|zeros|message),
 * data-expired-message, data-show-days (true|false), data-unit-labels (true|false)
 */
(function () {
  'use strict';

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function initRoot(root) {
    if (root.getAttribute('data-cd-inited') === '1') return;
    root.setAttribute('data-cd-inited', '1');

    var endSec = parseInt(root.getAttribute('data-end'), 10);
    if (!endSec || isNaN(endSec)) return;

    var expiredMode = root.getAttribute('data-expired') || 'hide';
    var expiredMsg = root.getAttribute('data-expired-message') || '';
    var showDays = root.getAttribute('data-show-days') !== 'false';
    var showUnitLabels = root.getAttribute('data-unit-labels') !== 'false';

    var labelRow = root.querySelector('[data-pongbot26-cd-label]');
    var timer = root.querySelector('[data-pongbot26-cd-timer]');
    var expiredEl = root.querySelector('[data-pongbot26-cd-expired]');
    var groups = root.querySelectorAll('[data-pongbot26-cd-group]');
    var vals = {
      d: root.querySelector('[data-pongbot26-cd-d]'),
      h: root.querySelector('[data-pongbot26-cd-h]'),
      m: root.querySelector('[data-pongbot26-cd-m]'),
      s: root.querySelector('[data-pongbot26-cd-s]'),
    };

    function applyUnitLabelsVisibility() {
      root.querySelectorAll('[data-pongbot26-cd-unit-label]').forEach(function (el) {
        el.style.display = showUnitLabels ? '' : 'none';
      });
    }
    applyUnitLabelsVisibility();

    function hideDayColumn() {
      groups.forEach(function (g) {
        if (g.getAttribute('data-pongbot26-cd-group') === 'd') g.style.display = 'none';
      });
    }
    if (!showDays) hideDayColumn();

    var tick = function () {
      var now = Math.floor(Date.now() / 1000);
      var left = endSec - now;

      if (left <= 0) {
        if (root._cdTimer) clearInterval(root._cdTimer);
        root._cdTimer = null;

        if (expiredMode === 'hide') {
          root.hidden = true;
          root.style.display = 'none';
          return;
        }

        if (expiredMode === 'message' && expiredMsg) {
          if (labelRow) labelRow.style.display = 'none';
          if (timer) timer.style.display = 'none';
          if (expiredEl) {
            expiredEl.textContent = expiredMsg;
            expiredEl.hidden = false;
          }
          return;
        }

        left = 0;
      }

      var d = 0,
        h = 0,
        m = 0,
        s = 0;
      if (showDays) {
        d = Math.floor(left / 86400);
        h = Math.floor((left % 86400) / 3600);
        m = Math.floor((left % 3600) / 60);
        s = left % 60;
      } else {
        h = Math.floor(left / 3600);
        m = Math.floor((left % 3600) / 60);
        s = left % 60;
      }

      if (vals.d) vals.d.textContent = pad2(d);
      if (vals.h) vals.h.textContent = showDays ? pad2(h) : String(h);
      if (vals.m) vals.m.textContent = pad2(m);
      if (vals.s) vals.s.textContent = pad2(s);
    };

    tick();
    root._cdTimer = setInterval(tick, 1000);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') tick();
    });
  }

  function boot() {
    document.querySelectorAll('[data-pongbot26-hero-countdown]').forEach(initRoot);
  }

  boot();

  if (!window.__pongbot26HeroCdListeners) {
    window.__pongbot26HeroCdListeners = true;
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  }
})();
